import { PaginatedResponse, useApi } from '@/api';
import { CardList, LinkButton, Link, ListSkeleton } from '@/components';
import {
  Flex,
  WalletAddress,
  CurrencyValue,
  ListItem
} from '@blockanalitica/ui';

type CollateralBuyer = {
  wallet_address: string;
  collateral_amount: string;
  base_amount: string;
  underlying_symbol: string;
  underlying_address: string;
  datetime: string;
  order_index: string;
};

export default function LatestCollateralBuyers({
  marketAddress,
  network,
  ...rest
}: {
  marketAddress: string;
  network: string;
}) {
  const [data, error] = useApi<PaginatedResponse<CollateralBuyer[]>>({
    url: `/markets/${marketAddress}/liquidations/collateral-buyers/`,
    queryParams: {
      limit: '5',
      sort: '-datetime'
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ListSkeleton />;
  }

  return (
    <CardList
      title="Latest Collateral Buyers"
      action={
        <LinkButton to="collateral-buyers" variant="secondary">
          view all
        </LinkButton>
      }
      {...rest}>
      {data['results'].length > 0 &&
        data['results'].map((row) => (
          <ListItem
            // @ts-ignore
            as={Link}
            key={row.order_index}
            to={`./collateral-buyers/${row.wallet_address}`}
            relative="path">
            <Flex justifyContent="space-between">
              <WalletAddress address={row.wallet_address} />

              <CurrencyValue
                value={row.collateral_amount}
                options={{
                  currency: {
                    name: row.underlying_symbol,
                    address: row.underlying_address,
                    network: network
                  }
                }}
              />
            </Flex>
          </ListItem>
        ))}
    </CardList>
  );
}
